import * as MutationTypes from "./mutation-types";

export const mutations = {
  [MutationTypes.TOGGLE_SNACKBAR](state, snackbarInfo) {
    state.snackbarInfo = snackbarInfo;
  },
  [MutationTypes.TOGGLE_SIDEBAR](state) {
    state.sidebar.isShow = !state.sidebar.isShow;
  },
  [MutationTypes.SET_LOADING](state, value) {
    state.isLoading = value;
  },
  [MutationTypes.UPDATE_TABLE_ITEMS](state, items) {
    state.itemsTable = items;
  },
  [MutationTypes.SET_HAS_LOGGED_USER](state) {
    state.hasLoggedUser = true;
  },
  [MutationTypes.SET_NO_HAS_LOGGED_USER](state) {
    state.hasLoggedUser = false;
  }
};
